module.exports = __webpack_public_path__ + "img/collection-engagementRings070Carat.95bab23.webp";